import { TAO_KOE, EN_KO } from './../libs';

TAO_KOE.ready( 'dynamic-store-location.js', function() {
	// Add class, when in viewport.
	const element = document.getElementById( 'dynamic-store-location' );
	if ( element ) {
		EN_KO.functions.initSimpleLazyLoadOnScroll( element, 'custom_element--in_view' );
	}
} );
